import { render, staticRenderFns } from "./footer-m.vue?vue&type=template&id=8723c12a&scoped=true&"
import script from "./footer-m.vue?vue&type=script&lang=js&"
export * from "./footer-m.vue?vue&type=script&lang=js&"
import style0 from "./footer-m.vue?vue&type=style&index=0&id=8723c12a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8723c12a",
  null
  
)

export default component.exports